import { ConversationType } from "../../constants/chat.constant";
import { ChatFolderDetail } from "../../interfaces/chat.interface";
import { ConversationComponent } from "./conversation";


/**
 * Props for the Conversations component
 */
interface Props {
  /** Type of conversations to display */
  conversationType: ConversationType;
  /** Array of conversation folder details */
  conversations: Array<ChatFolderDetail>;
  /** Callback to refetch conversation folders */
  refetchFolders?: () => void;
}

/**
 * Conversations component displays a list of conversation items. Maps over
 * conversations array and renders ConversationComponent for each item.
 * 
 * @component
 * @param {Props} props - Component props
 * @param {ConversationType} props.conversationType - Conversation type
 * @param {Array<ChatFolderDetail>} props.conversations - Array of conversations
 * @param {() => void} [props.refetchFolders] - Refetch folders callback
 * @returns {JSX.Element} List of conversation components
 * 
 * @example
 * ```tsx
 * <Conversations
 *   conversations={conversations}
 *   conversationType={ConversationType.STANDARD}
 *   refetchFolders={handleRefetch}
 * />
 * ```
 */
export const Conversations = ({ conversations, conversationType, refetchFolders }: Props) => {
  return (
    <div className="flex w-full flex-col gap-1">
      {conversations.map((conversation, index) => (
        <ConversationComponent key={conversation.session_id} conversation={conversation} conversationType={conversationType} refetchFolders={refetchFolders} />
      ))}
    </div>
  );
};
